import {
  GET_CHANGE_HISTORY,
  GET_CHANGE_HISTORY_SUCCESS,
  GET_CHANGE_HISTORY_ERROR,
  GET_CHANGE_HISTORY_EXPORT,
  GET_CHANGE_HISTORY_EXPORT_SUCCESS,
  GET_CHANGE_HISTORY_EXPORT_ERROR,
} from './actionTypes';
import { handleGetChangeHistory, handleGetChangeHistoryError, handleGetChangeHistorySuccess } from 'helpers/change_history_pagination_helper';

const initialState = {
  change_history: [],
  loading: false,
  error: null,
  last_page_fetched: 0,
  total_number_of_pages: 0,
  change_history_campaigns: [],
  change_history_brands: [],
  change_history_accounts: [],
  change_history_users: [],
  change_history_admin_users: [],
  last_start_date: null,
  last_end_date: null,
  has_next_page: false,
  history_export_loading: false,
  change_location_options: [],
  has_lookahead_pages: false,
  active_cache_key: null,
  page_cache: {},
  last_fetched_at: null,
};

const ChangeHistory = (state = initialState, action) => {
  switch (action.type) {
    case GET_CHANGE_HISTORY:
      return handleGetChangeHistory(state, action, {
        dataKey: 'change_history',
      });

    case GET_CHANGE_HISTORY_SUCCESS:
      return handleGetChangeHistorySuccess(state, action, {
        dataKey: 'change_history',
        additionalDataMap: {
          change_history_campaigns: 'campaigns',
          change_history_users: 'users',
          change_history_brands: 'brands',
          change_history_admin_users: 'admin_users',
          change_history_accounts: 'accounts',
          change_location_options: 'change_location_options',
        },
      });

    case GET_CHANGE_HISTORY_ERROR:
      return handleGetChangeHistoryError(state, action);

    case GET_CHANGE_HISTORY_EXPORT:
      return {
        ...state,
        history_export_loading: true,
      };

    case GET_CHANGE_HISTORY_EXPORT_SUCCESS:
      return {
        ...state,
        history_export_loading: false,
      };

    case GET_CHANGE_HISTORY_EXPORT_ERROR:
      return {
        ...state,
        history_export_loading: false,
      };

    default:
      return state;
  }
};

export default ChangeHistory;
